import type { TooltipProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

/**
 * Shared tooltip slotProps for consistent styling and popper behavior
 * (shadow, border, offset, flip, preventOverflow) across the app.
 * Spread and override (e.g. popper.anchorEl) as needed.
 */
export const TOOLTIP_PAPER_STYLE_SLOT_PROPS: NonNullable<TooltipProps['slotProps']> = {
  tooltip: {
    sx: {
      boxShadow: (theme: Theme) => theme.shadows[6],
      backgroundColor: 'background.paper',
      color: 'text.primary',
      border: (theme: Theme) => `1px solid ${theme.palette.divider}`,
    },
  },
  popper: {
    modifiers: [
      { name: 'offset', options: { offset: [0, 8] } },
      { name: 'flip', options: { fallbackPlacements: ['right', 'left-start', 'left-end'] } },
      { name: 'preventOverflow', options: { padding: 8 } },
    ],
  },
};
